module.exports = __webpack_public_path__ + "static/media/logo.14ec3558.gif";